// import React from "react";
// import {
//   Box,
//   Card,
//   Divider,
//   Grid,
//   Paper,
//   Typography,
//   Button,
//   Stack,
// } from "@mui/material";
// import { IMAGE_URL } from "network";
// import ContactPageIcon from "@mui/icons-material/ContactPage";

// export default function DocumentsTab({ beautician }) {
//   const onApprove = () => {};

//   const onReject = () => {};
//   return (
//     <Box>
//       <Card
//         sx={{
//           p: 4,
//           borderRadius: 6,
//           mb: 4,
//           boxShadow: 8,
//           background: "linear-gradient(to right, #fdf7e8ff, #e3f1c3ff)",
//           color: "#333",
//         }}
//       >
//         <Stack direction="row" alignItems="center" spacing={1} mb={2}>
//           <ContactPageIcon color="primary" />
//           <Typography variant="h6" fontWeight={600}>
//             Uploaded Documents
//           </Typography>
//         </Stack>

//         {beautician?.documents?.length ? (
//           beautician.documents.map((item, i) => (
//             <Paper
//               elevation={3}
//               sx={{
//                 p: 2,
//                 borderRadius: 3,
//                 transition: "transform 0.2s ease",
//                 "&:hover": { transform: "translateY(-4px)", boxShadow: 8 },
//                 display: "flex",
//                 alignItems: "center",
//                 justifyContent: "space-between",
//               }}
//             >
//               {/* <Box display="flex" alignItems="center"> */}
//               {Array.isArray(item.keyValue)
//                 ? item.keyValue.map((tem, idx) => (
//                     <img
//                       key={idx}
//                       src={IMAGE_URL + tem}
//                       alt={item.keyName || `Document ${idx + 1}`}
//                       height="50"
//                       width="50"
//                       style={{
//                         borderRadius: 8,
//                         objectFit: "cover",
//                         marginRight: 16,
//                         border: "2px solid #e0e0e0",
//                       }}
//                       crossOrigin="anonymous"
//                     />
//                   ))
//                 : item.keyValue && (
//                     <img
//                       src={IMAGE_URL + item.keyValue}
//                       alt={item.keyName || `Document 1`}
//                       height="50"
//                       width="50"
//                       style={{
//                         borderRadius: 8,
//                         objectFit: "cover",
//                         marginRight: 16,
//                         border: "2px solid #e0e0e0",
//                       }}
//                       crossOrigin="anonymous"
//                     />
//                   )}

//               <Typography
//                 variant="subtitle1"
//                 sx={{
//                   fontWeight: 500,
//                   whiteSpace: "nowrap",
//                   overflow: "hidden",
//                   textOverflow: "ellipsis",
//                 }}
//               >
//                 {item?.keyName || `Document ${i + 1}`}
//               </Typography>
//               {/* </Box> */}

//               {/* Status buttons */}
//               {item.status === "pending" && (
//                 <Stack direction="row" spacing={1}>
//                   <Button
//                     variant="contained"
//                     color="success"
//                     size="small"
//                     onClick={() => onApprove(item)}
//                   >
//                     Approve
//                   </Button>
//                   <Button
//                     variant="contained"
//                     color="error"
//                     size="small"
//                     onClick={() => onReject(item)}
//                   >
//                     Reject
//                   </Button>
//                 </Stack>
//               )}

//               {item.status === "approved" && (
//                 <Button
//                   variant="contained"
//                   color="success"
//                   size="small"
//                   disabled
//                 >
//                   Approved
//                 </Button>
//               )}

//               {item.status === "rejected" && (
//                 <Button variant="contained" color="error" size="small" disabled>
//                   Rejected
//                 </Button>
//               )}
//             </Paper>
//           ))
//         ) : (
//           <Typography color="text.secondary">
//             No documents uploaded yet.
//           </Typography>
//         )}
//       </Card>
//     </Box>
//   );
// }

import React, { useState } from "react";
import { Box, Card, Typography, Paper, Stack, Button, Dialog, DialogContent, IconButton } from "@mui/material";
import { IMAGE_URL } from "network";
import ContactPageIcon from "@mui/icons-material/ContactPage";
import CloseIcon from "@mui/icons-material/Close";
import VisibilityIcon from "@mui/icons-material/Visibility";
import Swal from "sweetalert2";
import { verifyBeauticianDocumentApi } from "services/beauticianApi";

export default function DocumentsTab({ beautician }) {
  const [documents, setDocuments] = useState(beautician?.documents || []);
  const [previewImg, setPreviewImg] = useState(null);

  const handleVerify = async (item, status) => {
    try {
      const payload = {
        userId: beautician._id,
        docId: item._id,
        status,
        rejectReason: status === "rejected" ? "Document not valid" : null,
      };

      const res = await verifyBeauticianDocumentApi(payload);
      Swal.fire({
        icon: "success",
        title: "Success",
        text: res.message,
        timer: 2000,
        showConfirmButton: false,
      });

      // update UI
      setDocuments((prev) =>
        prev.map((doc) => (doc._id === item._id ? { ...doc, status } : doc))
      );
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Failed",
        text: error.response?.data?.message || "Something went wrong",
      });
    }
  };

  return (
    <Box>
      <Card
        sx={{
          p: 4,
          borderRadius: 6,
          mb: 4,
          boxShadow: 8,
          background: "linear-gradient(to right, #fdf7e8ff, #e3f1c3ff)",
          color: "#333",
        }}
      >
        <Stack direction="row" alignItems="center" spacing={1} mb={2}>
          <ContactPageIcon color="primary" />
          <Typography variant="h6" fontWeight={600}>
            Uploaded Documents
          </Typography>
        </Stack>

        {documents?.length ? (
          documents.map((item, i) => (
            <Paper
              key={i}
              elevation={3}
              sx={{
                p: 2,
                borderRadius: 3,
                transition: "transform 0.2s ease",
                "&:hover": { transform: "translateY(-4px)", boxShadow: 8 },
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                mb: 2,
              }}
            >
              <Stack direction="row" spacing={2} alignItems="center">
                {(Array.isArray(item.keyValue) ? item.keyValue : [item.keyValue]).map((imgPath, idx) => (
                  <Box key={idx} sx={{ position: "relative", cursor: "pointer" }} onClick={() => setPreviewImg(IMAGE_URL + imgPath)}>
                    <img
                      src={IMAGE_URL + imgPath}
                      alt={item.keyName || `Document ${i + 1}`}
                      height="50"
                      width="50"
                      style={{
                        borderRadius: 8,
                        objectFit: "cover",
                        border: "2px solid #e0e0e0",
                      }}
                      crossOrigin="anonymous"
                    />
                    <Box sx={{ position: "absolute", bottom: 0, right: 0, bgcolor: "rgba(0,0,0,0.45)", borderRadius: "0 0 8px 0", display: "flex", p: "1px" }}>
                      <VisibilityIcon sx={{ fontSize: 14, color: "#fff" }} />
                    </Box>
                  </Box>
                ))}
                <Typography variant="subtitle1" fontWeight={500}>
                  {item?.keyName || `Document ${i + 1}`}
                </Typography>
              </Stack>

              {/* Buttons */}
              {item.status === "pending" && (
                <Stack direction="row" spacing={1}>
                  <Button
                    variant="contained"
                    color="success"
                    size="small"
                    onClick={() => handleVerify(item, "approved")}
                  >
                    Approve
                  </Button>
                  <Button
                    variant="contained"
                    color="error"
                    size="small"
                    onClick={() => handleVerify(item, "rejected")}
                  >
                    Reject
                  </Button>
                </Stack>
              )}

              {item.status === "approved" && (
                <Button
                  variant="contained"
                  color="success"
                  size="small"
                  disabled
                >
                  Approved
                </Button>
              )}

              {item.status === "rejected" && (
                <Button variant="contained" color="error" size="small" disabled>
                  Rejected
                </Button>
              )}
            </Paper>
          ))
        ) : (
          <Typography color="text.secondary">
            No documents uploaded yet.
          </Typography>
        )}
      </Card>

      {/* Preview Dialog */}
      <Dialog open={!!previewImg} onClose={() => setPreviewImg(null)} maxWidth="md">
        <DialogContent sx={{ p: 1, position: "relative" }}>
          <IconButton onClick={() => setPreviewImg(null)} sx={{ position: "absolute", top: 4, right: 4, zIndex: 1, bgcolor: "rgba(0,0,0,0.5)", color: "#fff", "&:hover": { bgcolor: "rgba(0,0,0,0.7)" } }} size="small">
            <CloseIcon fontSize="small" />
          </IconButton>
          <img src={previewImg} alt="Document Preview" style={{ maxWidth: "100%", maxHeight: "80vh", display: "block", borderRadius: 8 }} crossOrigin="anonymous" />
        </DialogContent>
      </Dialog>
    </Box>
  );
}
